<template>
  <div :loading="saveLoad" class="app-container">
    <div class="materialFormLine">广宣物料信息</div>
    <div class="budgetBox">
      <a-form-model ref="material" class="UniformCss form-container" :inline="true" :model="material" :rules="rules" label-width="100px">
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="物料号" prop="materialCode">
              <a-input v-model="material.materialCode" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="物料名称" prop="materialName">
              <a-input v-model="material.materialName" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="物料类型" prop="materialType">
              <a-select v-model="material.materialType">
                <a-select-option v-for="item in SelectLists.PromotionMaterialType" :key="item.code" :value="item.code" >{{item.value}}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="库存量" prop="storage">
              <a-input v-model="material.storage" type="number"/>
            </a-form-model-item>
          </a-col>
          <!-- lr004 -->
          <!-- <a-col :span="6">
            <a-form-model-item label="所属仓库" prop="warehouse">
              <a-select v-model="material.warehouse">
                <a-select-option v-for="item in SelectLists.PromotionStockType" :key="item.code" :value="item.code" >{{ item.value }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col> -->
          <a-col :span="6">
             <!-- lr002 -->
            <a-form-model-item label="申领单价(元）" prop="price">
              <a-input v-model="material.price" type="number"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="制作单价(元）" prop="prodPrice">
              <a-input v-model="material.prodPrice" type="number"/>
            </a-form-model-item>
          </a-col>
          <!-- lr005 -->
          <!-- <a-col :span="6">
            <a-form-model-item label="供应商" prop="supplier">
              <a-input v-model="material.supplier" />
            </a-form-model-item>
          </a-col> -->
        
          <!--
          <a-col :span="6">
            <a-form-model-item label="物料规格" prop="specification">
              <a-input v-model="material.specification" />
            </a-form-model-item>
          </a-col> -->
          <a-col :span="6">
            <a-form-model-item label="单位" prop="unit">
              <a-input v-model="material.unit" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="安全库存" prop="storageSafetyValue">
              <a-input-number v-model="material.storageSafetyValue" :min="0" :precision="0" />
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="6">
            <a-form-model-item label="物料说明" prop="caption">
              <a-input v-model="material.caption" />
            </a-form-model-item>
          </a-col> -->
              <!-- lr008 -->
          <!-- <a-col :span="6">
            <a-form-model-item label="可见范围" >
              <a-select v-model="material.materialType">
                <a-select-option v-for="item in SelectLists.PromotionMaterialType" :key="item.code" :value="item.code" >{{item.value}}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col> -->
          <a-col :span="24">
            <a-form-model-item label="备注" prop="remark">
              <!-- <a-input v-model="material.remark" /> -->
              <!-- <a-textarea v-model="material.remark" :rows="3" /> -->
              <a-textarea v-model="material.remark" :rows="1.5" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <!-- <a-row>
          <a-col :span="10">
            <a-form-model-item label="品系" >
            <label v-for="option in options" :key="option" class="checkbox-label">
              <input type="checkbox" v-model="selectedOptions" :value="option">
              {{ option }}
            </label>
          </a-form-model-item>
          </a-col>
        </a-row> -->
        <a-row>
          <a-col>
            <a-form-model-item label="物料图片">
              <el-upload
                ref="upload"
                class="upload-demo"
                accept=".jpg,.png"
                :limit="4"
                action=""
                list-type="picture-card"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :on-change="onChangeImg"
                :file-list="fileList"
                multiple
                :auto-upload="false">
                <i class="el-icon-plus" />  
=                <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，每张不超过2M，最多上传3张</div> -->
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，每张不超过2M，最多上传4张</div>
              </el-upload>
              <a-modal width="40%" v-model="dialogVisible" :footer="null">
                <img width="100%" :src="dialogImageUrl" alt="">
              </a-modal>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <div class="btn-container">
        <vxe-button  @click="returnFun()">返回</vxe-button>
        <vxe-button  status="primary" @click="onSubmit()">保存</vxe-button>
      </div>
    </div>
  </div>
</template>
<script>
import { addMaterial } from '@/api/material'
// import { updateMaterial } from '@/api/material'

export default {
  name: 'AddMaterial',
  data() {
    return {
      // options: ['工程', '牵引', '载货', '轻卡', '专用', '新能源', '氢能源'],
      // selectedOptions: [],
      material: {},
      rules: {
        materialCode: [{ required: true, message: '请输入物料编号', trigger: 'blur' }],
        materialName: [{ required: true, message: '请输入物料名称', trigger: 'blur' }],
        materialType: [{ required: true, message: '请选择物料类型', trigger: 'blur' }],
        unit: [{ required: true, message: '请输入单位', trigger: 'blur' }],
        // storage: [{ required: true, message: '请输入库存', trigger: 'blur' }],
        storage: [{ required: true, message: '请输入数量', trigger: 'blur' }],
        // warehouse: [{ required: true, message: '请选择所属仓库', trigger: 'blur' }],
        price: [{ required: true, message: '请输入申领价（元）', trigger: 'blur' }],
        prodPrice: [{ required: true, message: '请输入制作价（元）', trigger: 'blur' }],
        // supplier: [{ required: true, message: '请输入供应商', trigger: 'blur' }]
        storageSafetyValue: [{ required: true, message: '请输入安全库存）', trigger: 'blur' }],
      },
      fileType: ['image/png', 'image/jpeg','image/jpg'],
      fileList: [],
      saveLoad: false,
      SelectLists: {},
      dialogVisible: false,
      dialogImageUrl: ''
    }
  },
  created() {
    // 获取下拉框列表
    this.SelectListFun()
  },
  methods: {
    // uploadBefore(file) {

    // },
    // beforeUpload(file) {
    //   const isJPGorPNG = file.type === 'image/jpeg' || file.type === 'image/png';
    //   const isLt500K = file.size / 1024 < 2;
 
    //   if (!isJPGorPNG) {
    //     this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
    //     return false;
    //   }
    //   if (!isLt500K) {
    //     this.$message.error('上传头像图片大小不能超过 2M!');
    //     return false;
    //   }
    //   return true; // 如果返回 false 或者返回 Promise 且被 reject，停止上传。
    // },
 
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    // onChangeImg(file, fileList) { 
    //   const type = file.raw.type
    //   const isCorrectType = this.fileType.find(item => item === type)
    //   if (!isCorrectType) {
    //     this.$message('图片仅支持jpg或png格式')
    //     fileList.pop()
    //   } else {
    //     const size = file.size / 1024 / 1024
    //     if (size > 2) {
    //       this.$message('图片大小不得超过2M')
    //       fileList.pop()
    //     } else {
    //       this.fileList = fileList
    //     }
    //   }
    // },  原先没有成功限制2M大小

    onChangeImg(file, fileList) {
      // const type = file.raw.type
      // const isCorrectType = this.fileType.find(item => item === type)
      const type = file.raw.type;
      const isCorrectType = this.fileType.includes(type);
      if (!isCorrectType) {
        this.$message.error('图片仅支持jpg或png格式')
        fileList.pop()
      } 
        const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
          // this.$refs.upload.clearFiles()
          fileList.pop()
             this.$message.error('上传文件大小不能超过 2MB!')
            return false
       }
       else {
        this.fileList = fileList
      } },
    
    onSubmit() {
      this.$refs.material.validate((valid) => {
        if (valid) {
          let formData = new FormData()
          this.fileList.forEach(item => {
            formData.append('file', item.raw)
          })

          const data = JSON.stringify(this.material)
          formData.append('material', new Blob([data], { type: 'application/json' }))
          this.saveLoad = true
          addMaterial(formData).then(res => {

          // updateMaterial(formData).then(res => {
            if (res.code === 1) {
              this.$message.success('保存成功')
              this.returnFun()
            } else {
              this.$message.error(res.message)
            }
            this.saveLoad = false
          })
        } else {
          this.$message.error('请完善物料信息!')
        }
      })
    },
    returnFun() {
      this.returnListFun()
    },
    returnListFun() {
      // 跳转路由
      this.$closePage('/publicizeMaterialManagement/addMaterial', '/publicizeMaterialManagement/publicizeMaterialMaintenance')
    },
    // 获取下拉列表
    SelectListFun() {
      this.$store.dispatch('SelectData/QuerySelect', ['PromotionMaterialType', 'PromotionStockType']).then(v => {
        this.SelectLists = v
      })
    }
  }
}

</script>

<style lang="less" scoped>
.materialFormLine {
  margin: 0;
  padding: 0px 20px;
  width: 100%;
  background: #0a76a4;
  color: #ffffff;
  height: 30px;
  line-height: 30px;
}
.btn-container {
  margin-top: 60px;
  display: flex;
  justify-content: center;
}
/deep/ .el-upload__input {
  display: none!important;;
}
/* 隐藏多余的上传框 */
/* 完全隐藏上传框 */
.upload-demo .el-upload--picture-card {
  display: none;
}
.upload-demo .el-upload--picture-card:nth-child(4) {
  display: block; /* 只显示第四个上传框 */
}
.checkbox-label {
  margin: 3px;
  font-size: 15px;
  color: #181329;
}
</style>
